import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Css/Tools.css";
import "./Css/Tools-responsive.css";

import { Ripple } from "primereact/ripple";
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import NoDataCreated from "../../../Components/NoDataCreated";
import ErrorPage from "../../../Components/ErrorPage";
import PageLoader from "../../../Components/PageLoader";
import { goToTop } from "../../../Components/goToTop";
import { baseURL } from "../../../Api/ApiConstant";

import ToolModal from "./ToolModal";
import { ToolListData } from "../../../Controllers/Types/HeyTraderTypes/Tools/ToolListData";
import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import { getToolList } from "../../../Controllers/Thunks/HeyTraderThunks";
import { useSelector } from "react-redux";
import { hasPermission } from "../../../Controllers/Selectors/permissionsSelector";
import { RootState } from "../../../Controllers/Store";
import { CommonProjectType, mapCommonProjectType } from "../../../Controllers/Types/HeyTraderTypes/CommonProjectType";
import { Project } from "../../../Controllers/Types/Project/ProjectInterface";

const Tools: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const loadingPage = useAppSelector((state) => state?.toolsList?.loader);
  const error = useAppSelector((state) => state?.toolsList?.errorDisplay);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const toast = useRef<Toast>(null);
  const [dataState, setDataState] = useState<"Add" | "Edit">("Add");
  const noImageIcon = "/assets/images/icons/no_img.svg";
  // main project given
  const [mainProjectx, setMainProject] = useState<CommonProjectType | null>(null);
  /* Tool */
  const [toolsData, setToolsData] = useState<ToolListData[]>([]);
  const [showToolModal, setShowToolModal] = useState<boolean>(false);

  /* *********************************** Tool ********************************** */

  useEffect(() => {
    if (location.state && location?.state?.mainProject) {
      const mainproject = location?.state?.mainProject as Project;

      if (mainproject && mainproject !== null) {
        const data: any = {
          project_id: mainproject?.project_id!,
          job_number: mainproject?.job_number!,
          project_type: mainproject?.project_type!,
          description: mainproject?.description!,
          status: mainproject?.status,
          full_address: mainproject?.address
        }
        setMainProject(mapCommonProjectType(data));
      }
      // need to set tools data
    } else {
      setMainProject(null);
    }
  }, [location?.state]);



  // PERMISION HANDLER
  const useCanEdit = (screen: string, permission: string) => {
    return useSelector((state: RootState) =>
      hasPermission(state, screen, permission)
    );
  };

  const add_data = useCanEdit("Tools", "add_tool");


  // database fetch and set values as well.

  // for the resons
  const dispatch = useAppDispatch();

  // this is get data from state list and set projectlist
  const toolListData = useAppSelector((state) => state.toolsList.toolList);

  // for fetching data fro api tigger with state object actions
  useEffect(() => {
    dispatch(getToolList());
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      const filteredtools = toolListData?.filter((tool) => tool?.status === 1);
      if (filteredtools && filteredtools.length > 0) {
        setToolsData(filteredtools);
      } else {
        setToolsData([]);
      }
    };
    fetchData();
  }, [toolListData]);

  const handleCloseToolModal = () => {
    setShowToolModal(false);
  };

  const handleAddTool = () => {
    setShowToolModal(true);
    setDataState("Add");
  };

  const toolDisplayBody = (rowData: ToolListData) => {
    const toolImage = rowData?.path && baseURL + rowData?.path;
    const toolCategoryName = rowData?.category_name;

    return (
      <div className="tool_display">
        {toolImage ? (
          <img
            src={toolImage!}
            className="tool_display_img"
            alt={toolCategoryName}
          />
        ) : (
          <span className="tool_display_img no_img">
            <img src={noImageIcon} alt={toolCategoryName} />
          </span>
        )}
        <span>{toolCategoryName}</span>
      </div>
    );
  };

  const handleViewTool = (data: ToolListData) => {
    const toolListData = data;
    navigate(`items`, { state: { toolListData: toolListData, mainProject: mainProjectx } });
    goToTop();
  };

  const tableActionBody = (rowData: ToolListData) => {
    return (
      <div className="table_action_btn_area">
        <button
          className="table_action_btn p-ripple"
          onClick={() => handleViewTool(rowData)}
        >
          View
          <Ripple />
        </button>
      </div>
    );
  };
  /* *************************************************************************** */

  /* ***************************** Common function ***************************** */
  const handleSuccess = (message: string) => {
    setSuccessMessage(message);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
  };

  const goBack = () => {
    navigate(-1);
    goToTop();
  };
  /* *************************************************************************** */

  return (
    <React.Fragment>
      <Toast ref={toast} />

      <div className="main_content layout_padding show_side_bar">
        {loadingPage ? (
          <PageLoader />
        ) : error ? (
          <ErrorPage errorMessage={error} />
        ) : (
          <div className="page_content mt-0">

            {(mainProjectx && mainProjectx !== null) ? (
              <div className="page_breadcrumb_area">
                <ul className="page_breadcrumb">
                  <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                    {mainProjectx.job_number}: {mainProjectx.address}
                  </li>
                  <li className="page_breadcrumb_item active">
                    Tools
                  </li>
                </ul>

                <button className="back_btn p-ripple" onClick={goBack}>
                  <i className="bi bi-arrow-left me-2"></i>
                  Back
                  <Ripple />
                </button>
              </div>
            ) : (
              <div className="d-flex align-items-center justify-content-between">
                <h4 className="main_heading">Tools</h4>
                <button className="back_btn p-ripple" onClick={goBack}>
                  <i className="bi bi-arrow-left me-2"></i>
                  Back
                  <Ripple />
                </button>
              </div>
            )}

            <div className="page_header_area justify-content-end mt-sm-3 mt-3">
              <div className="page_action_area">
                {add_data && (
                  <button
                    className="add_data_link_btn p-ripple"
                    onClick={handleAddTool}
                  >
                    <i className="bi bi-plus-circle"></i>
                    <span>Add tool</span>
                    <Ripple />
                  </button>
                )}
              </div>
            </div>

            <div className="page_main_content_section">
              {toolsData && toolsData?.length > 0 ? (
                <DataTable
                  value={toolsData}
                  paginator
                  size="small"
                  rows={10}
                  emptyMessage="No data found!"
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  tableStyle={{ minWidth: "50rem" }}
                  paginatorDropdownAppendTo={"self"}
                  paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                  className="page_table p-0 p-sm-2"
                  rowHover
                >
                  <Column
                    header="No."
                    headerClassName="text_purple"
                    className="text_bold"
                    body={(rowData: ToolListData, { rowIndex }) => (
                      <span>{rowIndex + 1}.</span>
                    )}
                    style={{ width: "10%" }}
                  ></Column>

                  <Column
                    header="Tool category"
                    headerClassName="text_purple"
                    body={toolDisplayBody}
                    style={{ width: "70%" }}
                  ></Column>

                  <Column
                    header="Count"
                    alignHeader={"center"}
                    headerClassName="text_purple"
                    className="text_bold text-center"
                    body={(rowData: ToolListData) => (
                      <span>
                        {String(rowData?.tool_type_count ? rowData?.tool_type_count : 0).padStart(2, "0")}
                      </span>
                    )}
                    style={{ width: "10%" }}
                  ></Column>

                  <Column
                    body={tableActionBody}
                    className="table_btn_area"
                    style={{ width: "10%" }}
                  ></Column>
                </DataTable>
              ) : (
                <NoDataCreated message={`No tools have been added yet`} />
              )}
            </div>
          </div>
        )}
      </div>

      {/* Tool modal */}
      <ToolModal
        isOpen={showToolModal}
        dataState={dataState}
        onClose={handleCloseToolModal}
        onSuccess={handleSuccess}
        toast={toast}
        mainProject={mainProjectx}
      />
      {/*  */}

      {/* Show success message */}
      <div
        className={`message_backdrop ${showAlert ? "show" : ""}`}
        onClick={handleCloseAlert}
      >
        <div
          className={`message_box ${showAlert ? "show" : ""}`}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="message_box_content">
            <i className="bi bi-check-circle-fill message_box_icon"></i>
            <h6 className="message_box_message">{successMessage}</h6>
          </div>
        </div>
      </div>
      {/*  */}
    </React.Fragment>
  );
};

export default Tools;
